import React, { Component } from 'react';
import { Card, CardText, CardBody, Button, FormGroup,  Label, Input, Col, Row ,CardHeader ,CardFooter, CardTitle, Alert} from 'reactstrap';
import { metadataService, newLoanService} from '../../_services'
import PropTypes from "prop-types";
import { ReadOnlyField, SlBusyIndicator, SlButton, SlRadioButton, SlMoneyInput, SlPageTitle, SlSectionLabel } from '../editors';
import { newLoanConstants } from '../../_constants';

export class IncreaseRefinanceLoan extends Component {
    static displayName = IncreaseRefinanceLoan.name;
    constructor(props) {
        super(props);
        
        this.handleOptionSelected = this.handleOptionSelected.bind(this);
        this.handleAmountChanged = this.handleAmountChanged.bind(this); 
        this.handleRequestLoan = this.handleRequestLoan.bind(this);
        

    }    
    
    handleOptionSelected(e){
        const newOption = parseInt(e.target.value, 10);
        this.props.optionsChanged({requestType: newOption, requestedAmount: newOption === 1 ? this.props.loan.originalLoanAmount : this.props.amount});
    }
    handleAmountChanged(e){
        const newAmount = parseFloat(e.target.value); 
        this.props.optionsChanged({ requestType: this.props.requestType, requestedAmount : newAmount})
    }

    handleRequestLoan(){
        this.props.requestLoan(); 
    }

    render() {
        return (
          <div className="CurrentLoan">           
            <div>
              <Row className="justify-content-center">
                <Col  xs={12} sm={12} md={8} lg={8} className="text-left">
                  <Card className="text-left border">
                    <CardHeader className="bg-primary">{metadataService.getTitle("SelectedLoan")}</CardHeader>
                    <CardBody>                     
                      <p class="lead">
                                        {metadataService.getFieldNameLabel("CurrentLoanId")}{": "}{this.props.loan.currentLoanId}
                      </p>
                      <p className='m-0'><small>{metadataService.getFieldNameLabel("OriginalLoanAmount")}</small></p>
                      <h2 className='h2-title '>{metadataService.formatMoney(this.props.loan.originalLoanAmount)}</h2>
                      <p>
                         {metadataService.getFieldNameLabel("RemainingLoanAmount")}{": "}{metadataService.formatMoney(this.props.loan.balance)}
                      </p>
                    </CardBody>
                  </Card>
                </Col>
              </Row>            
            </div>
            <div className="padTop">
              <Row className="justify-content-center">
                <Col xs={12} sm={12} md={8} lg={8} className="text-left">
                    <SlRadioButton fieldName="IncreaseRefinance" value={1} isSelected={this.props.requestType === 1}
                        onChange={this.handleOptionSelected}>
                        {metadataService.getFieldNameLabel('RefinanceLoan')}
                    </SlRadioButton>
                    <SlRadioButton fieldName="IncreaseRefinance" value={2} isSelected={this.props.requestType === 2}
                        onChange={this.handleOptionSelected}>
                        {metadataService.getFieldNameLabel('IncreaseLoan')}
                    </SlRadioButton>
                </Col>
              </Row>
            </div>
             {this.props.requestType === 1 && (
            <div id="refinance">
              <Row className="justify-content-center">
                <Col xs={12} md={8}>
                  <div className="text-left padTop">
                      {metadataService.getMessage("RefinanceLoanText")}
                  </div>
                </Col>
              </Row>
              <Card>
                <CardBody className="pl-0 pr-0">
                    <Row className="justify-content-center">
                      <Col xs={12} sm={12} md={8} lg={8}>
                        <Alert color="secondary" className="ml-0 mr-0 pl-0">
                        <h6 className='h6-title mt-4 mb-4'>{metadataService.getLabel("RefinanceAmount")}</h6>                        
                        <div className="bigNotification">{metadataService.formatMoney(this.props.loan.originalLoanAmount)}</div>  
                        </Alert>
                      </Col>
                                </Row>
                   {(this.props.loan.brSameLoan && Number(this.props.loan.brSameLoan)> 0) &&  <Row className="justify-content-center">
                    <Col xs={12} sm={12} md={8} lg={8}>
                        <Alert color="secondary" className="ml-0 mr-0 pl-0">
                            <h6 className='h6-title mt-4 mb-4'>{metadataService.getLabel("ReceiveAmount")}</h6>
                            <div className="bigNotification">{metadataService.formatMoney(this.props.loan.brSameLoan)}</div>
                        </Alert>
                    </Col>
                    </Row>}
                </CardBody>
              </Card>
            </div>)}           
            {this.props.requestType === 2 && (
            <div id="increase">
              <Card className="mt-3">
                <CardBody>
                    <Row className="justify-content-center">
                      <Col xs={12} sm={12} md={8} lg={8}>
                        <div className="text-left mt-3">
                          {metadataService.getMessage('IncreaseLoanText')}
                        </div>
                        <h6 className='h6-title mt-3'>{metadataService.getLabel("IncreaseAmount")}</h6>
                      </Col>
                    </Row>
                    <Row className="justify-content-center">
                      <Col xs={12} sm={12} md={8} lg={8}>
                        <div  >
                          <FormGroup className="mt-0">                                                                                                    
                            <SlMoneyInput name='IncreaseAmount' onChange={this.handleAmountChanged}
                                fieldErrors={this.props.fieldErrors} value={this.props.requestedAmount} minAmount={0} maxAmount={newLoanConstants.MAX_REQUEST_AMOUNT} step='1' showLabel={false}/>
                          </FormGroup>
                        </div>
                        </Col>
                    </Row>
                </CardBody>
              </Card>
            </div>)}
              {this.props.requestType > 0 && (
              <div className="text-center tinyText">
                <small>
                  {metadataService.getMessage("IncreaseRefinanceDisclaimer")}
                  </small>
              </div>
              )}
            {this.props.isEdit !== true  && <div className="text-center">
              <SlButton size="lg" name="Next" disabled={
                  !((this.props.requestType === 2 && this.props.requestedAmount && !this.props.formError) 
                  || this.props.requestType === 1)} onClick={this.handleRequestLoan}/>
            </div>}
          </div>
        );
    }

    

}

IncreaseRefinanceLoan.propTypes = {
    loan : PropTypes.object.isRequired, 
    optionsChanged : PropTypes.func.isRequired, 
    requestLoan: PropTypes.func.isRequired, 
    requestType : PropTypes.number, 
    fieldErrors: PropTypes.array,
    minLoanAmount : PropTypes.number,
    maxLoanAmount : PropTypes.number,
    isEdit : PropTypes.bool
};
IncreaseRefinanceLoan.defaultProps = {
  isEdit : false
}


// WEBPACK FOOTER //
// ./src/components/subcomponents/IncreaseRefinanceLoan.js